import Http from '../common/http';
import ApiUtil from '../utils/api.util';

const RESOURCE_NAME = 'broadcast';

const BroadcastService = {
 getList() {
    return Http.get(`/${RESOURCE_NAME}/list`);
  },
};

export default BroadcastService;
